import { StoreState } from '@/core/models/store.interface';
import { ActionContext } from 'vuex';

import { RoleService } from './role.service';
const service = new RoleService();

export interface RoleState {}

const state: RoleState = {};

const getters = {};

const mutations = {};

const actions = {
   async getRoles(context: ActionContext<RoleState, StoreState>, payload: { moduleId: number; userId: number }) {
      return await service.getRoles(payload.moduleId, payload.userId);
   },
};

export default {
   namespaced: true,
   state,
   getters,
   mutations,
   actions,
};
